import {ChildEntity} from "typeorm";
import {Notification} from "@/modules/notifications/entity";
import {LocationAsRelativeRaw} from "vue-router";
import {ShallowRef} from "vue";
import {Component} from "@vue/runtime-core";
import PlayerSuspendedNotificationComponent from "@/modules/competitions/components/PlayerSuspendedNotification.vue";
import {CardEnum} from "@/modules/match/enums";
import {Suspension} from "@/modules/competitions/entity/Suspension";

@ChildEntity()
export class PlayerSuspendedNotification extends Notification {
  setPayload(suspension: Suspension) {
    this.payloadRaw = JSON.stringify({
      playerId: suspension.player.id,
      playerName: suspension.player.shortName,
      card: suspension.card,
      matches: suspension.remainingMatches,
      competitionId: suspension.competitionId,
      competitionName: suspension.competition.name,
    });

    return this;
  }

  get payload(): { playerId: number, playerName: string, card: CardEnum, matches: number, competitionId: number, competitionName: string } {
    return JSON.parse(this.payloadRaw!);
  }

  get to(): LocationAsRelativeRaw | undefined {
    return {name: 'squads.formation'};
  }

  get component(): ShallowRef<Component> {
    return shallowRef(PlayerSuspendedNotificationComponent);
  }
}